import { NavLink, useLocation } from "react-router-dom";
import { Home, CheckSquare, Plus, ClipboardList, Bell } from "lucide-react";
import { cn } from "@/lib/cn";

const navItems = [
  { to: "/home", icon: Home, label: "Home" },
  { to: "/tasks", icon: CheckSquare, label: "Tasks" },
  { to: "/tasks/new", icon: Plus, label: "", isAction: true },
  { to: "/task-requests", icon: ClipboardList, label: "Requests" },
  { to: "/notifications", icon: Bell, label: "Inbox" },
];

export function MobileBottomNav() {
  const location = useLocation();

  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-50 border-t border-[var(--border)] bg-[var(--card)] md:hidden safe-area-bottom"
      aria-label="Main navigation"
      role="navigation"
    >
      <div
        className="flex items-center justify-around px-2"
        style={{ height: "var(--bottom-nav-height)" }}
      >
        {navItems.map((item) => {
          const isActive = item.isAction
            ? false
            : location.pathname === item.to ||
              (item.to === "/home" && location.pathname === "/");

          return (
            <NavLink
              key={item.to}
              to={item.to}
              className={cn(
                "flex flex-1 flex-col items-center justify-center gap-0.5 py-2 transition-all duration-150",
                item.isAction
                  ? "relative -mt-4"
                  : isActive
                    ? "text-[var(--color-primary)]"
                    : "text-[var(--color-mute)] active:text-[var(--color-body)]",
              )}
            >
              {item.isAction ? (
                <div className="flex h-12 w-12 items-center justify-center rounded-full bg-[var(--color-primary)] text-white shadow-lg shadow-[var(--color-primary)]/30 transition-transform active:scale-95">
                  <Plus className="h-6 w-6" strokeWidth={2.5} />
                </div>
              ) : (
                <>
                  <item.icon
                    className={cn(
                      "h-5 w-5 transition-all duration-150",
                      isActive && "scale-110",
                    )}
                    strokeWidth={isActive ? 2.5 : 2}
                    aria-hidden="true"
                  />
                  <span
                    className={cn(
                      "text-[10px] leading-tight font-medium transition-all duration-150",
                      isActive && "font-semibold",
                    )}
                    aria-hidden="true"
                  >
                    {item.label}
                  </span>
                </>
              )}
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
}
